import Logger from '../Logger'
export default class NeverKnowinglyUndersoldComponent {
  constructor(rootElement) {
    this.rootElement = rootElement;
    this.logger = new Logger(this.rootElement.id);
  }

  render(state) {
    `${state} represents the form state`;
  }

  hide() {
    if (this.rootElement.classList && !this.rootElement.classList.contains('u-hidden')) {
      this.logger.debug(`Hiding`);
      this.rootElement.classList.add('u-hidden');
    }
  }

  show() {
    if (this.rootElement.classList && this.rootElement.classList.contains('u-hidden')) {
      this.logger.debug(`Showing`);
      this.rootElement.classList.remove('u-hidden');
    }
  }

  disableChildInputs() {
    const children = this.rootElement.querySelectorAll('input:enabled, select:enabled, textarea:enabled, button:enabled');
    for (let i = 0; i < children.length; i++) {
      this.logger.debug(`Disabling ${children.length} child inputs`);
      children[i].disabled = true;
    }
  }

  enableChildInputs() {
    const children = this.rootElement.querySelectorAll('input:disabled, select:disabled, textarea:disabled, button:disabled');
    for (let i = 0; i < children.length; i++) {
      this.logger.debug(`Enabling ${children.length} child inputs`);
      children[i].disabled = false;
    }
  }
}
